import { Anchor, Box, Flex, Image, Stack, Text } from "@mantine/core";
import { Card } from "@onengine/component-library";
import { createFileRoute } from "@tanstack/react-router";
import styles from "@/routes/sp-invite/review/terminal-screen.module.scss";

export const Route = createFileRoute("/sp-invite/review/alignment-scheduled/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box className={styles.successContainer}>
      <Stack style={{ maxWidth: 600 }} gap={"var(--spacing-x-large, 24px)"}>
        <Stack>
          <Image style={{ width: "64px" }} src={"/favicon.svg"} alt="Success" />
          <Text className={styles.successHeaderText}>Alignment Call Scheduled</Text>
        </Stack>
        <Card style={{ padding: "var(--spacing-medium, 16px)" }}>
          <Stack className={styles.successDescriptionText} gap={"var(--spacing-large,20px)"}>
            <Text>{`Your alignment call is scheduled for [Day, Month] at [Time].`}</Text>
            <Text>{`Please reach out if you need to reschedule your call.`}</Text>
          </Stack>
        </Card>
        <Card style={{ padding: "var(--spacing-medium, 16px)" }}>
          <Stack className={styles.successDescriptionText} gap={"var(--spacing-large,20px)"}>
            <Flex wrap="wrap">
              Need to add more documents? You can upload additional Trade Licenses, Certifications,
              Insurance, or Vehicle Photos while we review.
              <Anchor
                href="/"
                c={"var(--text-brand-default, #004DDB)"}
                underline="always"
                style={{ textUnderlineOffset: 2 }}
              >
                Upload More Documents
              </Anchor>
            </Flex>
            <Text>If you have any questions, reach out to us at info@servengine.com</Text>
          </Stack>
        </Card>
      </Stack>
    </Box>
  );
}
